import evaluationOnTraining from 'actions/training/evaluation';
import Layout from 'components/Layout';
import Button from 'components/UI/Button';
import Container from 'components/UI/Container';
import Dropdown from 'components/UI/Dropdown';
import { TextInput } from 'components/UI/Form/Input';
import HeroLayout from 'components/UI/HeroLayout';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import {
    traingingAchievedOptions,
    trainingRatingOptions,
    trainingShareOptions,
} from 'utilities/filterOptions';
import { useFormValues } from 'utilities/useFormValues';
import './index.module.scss';

export default function Evaluation() {
    const dispatch = useDispatch();

    const [displayMessage, setDisplayMessage] = useState('');
    const [trainingRatingSelected, setTrainingRatingSelected] = useState('');
    const [trainingAchievedSelected, setTrainingAchievedSelected] = useState(
        ''
    );
    const [trainingShareSelected, setTrainingShareSelected] = useState('');

    const { formValues, handleChange } = useFormValues(
        {
            first_name: '',
            last_name_prefix: '',
            last_name: '',
            school: '',
            mark_explanation: '',
            learning_goal: '',
            good_points: '',
            improvements: '',
            available_for_contact: '',
            remarks: '',
        },
        () => setDisplayMessage('')
    );

    const {
        firstName,
        lastNamePrefix,
        lastName,
        school,
        markExplanation,
        learningGoal,
        goodPoints,
        improvements,
        recommendedTrainingExplanation,
        availableForContact,
        remarks,
    } = formValues;

    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(true);

    const { pathname } = useLocation();
    const code = pathname?.split('/')?.[2];

    function handleSubmit(e) {
        e.preventDefault();

        dispatch(
            evaluationOnTraining({
                ...formValues,
                mark: trainingRatingSelected,
                learning_goal_achieved: trainingAchievedSelected,
                recommend_training: trainingShareSelected,
                code,
            })
        )
            .then(() => {
                setConfirmModalIsOpen(false);
            })
            .catch(() =>
                setDisplayMessage('Er ging iets mis met de aanmelding')
            );
    }

    return (
        <Layout>
            <Container>
                <HeroLayout>
                    {confirmModalIsOpen ? (
                        <div styleName="wrapper">
                            <div styleName="content">
                                <h3>Evaluatie training</h3>
                                <form onSubmit={handleSubmit}>
                                    <div styleName="column">
                                        <div>
                                            <TextInput
                                                label="Voornaam"
                                                name="first_name"
                                                value={firstName}
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Tussenvoegsel"
                                                required={false}
                                                name="last_name_prefix"
                                                value={lastNamePrefix}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Achternaam"
                                                name="last_name"
                                                value={lastName}
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="School"
                                                name="school"
                                                value={school}
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div styleName="dropdown">
                                            <Dropdown
                                                group="rating"
                                                type="radio"
                                                text="Welk cijfer zou je de training geven?*"
                                                options={trainingRatingOptions.map(
                                                    (e) => e.long
                                                )}
                                                selected={
                                                    trainingRatingSelected
                                                }
                                                setSelected={
                                                    setTrainingRatingSelected
                                                }
                                                name="rating_option"
                                                value={trainingRatingSelected}
                                                onchange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Eventuele toelichting"
                                                name="mark_explanation"
                                                type="text"
                                                value={markExplanation}
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Wat was je leerdoel?*"
                                                name="learning_goal"
                                                type="text"
                                                value={learningGoal}
                                                required
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div styleName="column">
                                        <div styleName="dropdown">
                                            <Dropdown
                                                group="achieved"
                                                type="radio"
                                                text="Is het doel bereikt?*"
                                                options={traingingAchievedOptions.map(
                                                    (e) => e.long
                                                )}
                                                selected={
                                                    trainingAchievedSelected
                                                }
                                                setSelected={
                                                    setTrainingAchievedSelected
                                                }
                                                name="learning_goal_achieved"
                                                value={trainingAchievedSelected}
                                                onchange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Wat vond je goed aan de training?*"
                                                name="good_points"
                                                type="text"
                                                value={goodPoints}
                                                required
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Wat vond je minder goed aan de training?*"
                                                name="improvements"
                                                type="text"
                                                value={improvements}
                                                required
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div styleName="dropdown">
                                            <Dropdown
                                                group="share"
                                                type="radio"
                                                text="Zou je de training aanraden aan een collega?*"
                                                options={trainingShareOptions.map(
                                                    (e) => e.long
                                                )}
                                                selected={trainingShareSelected}
                                                setSelected={
                                                    setTrainingShareSelected
                                                }
                                                name="recommend_training"
                                                value={trainingShareSelected}
                                                onchange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Eventuele toelichting"
                                                name="recommend_training_explanation"
                                                type="text"
                                                value={
                                                    recommendedTrainingExplanation
                                                }
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div styleName="trainingExp">
                                            <p>
                                                Mogen we je benaderen als we
                                                graag meer willen weten hoe je
                                                de training hebt ervaren? Zo ja,
                                                laat hieronder je naam en
                                                e-mailadres achter.
                                            </p>
                                            <TextInput
                                                name="available_for_contact"
                                                type="text"
                                                value={availableForContact}
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div>
                                            <TextInput
                                                label="Overige opmerkingen / aanvullingen:"
                                                name="remarks"
                                                type="text"
                                                value={remarks}
                                                onChange={handleChange}
                                                required={false}
                                            />
                                        </div>
                                        <div />
                                    </div>
                                    <div styleName="bottom">
                                        <p>
                                            Vragen met een * zijn verplicht om
                                            in te vullen.
                                        </p>
                                        {displayMessage && (
                                            <p styleName="error">
                                                {displayMessage}
                                            </p>
                                        )}
                                        <div>
                                            <Button>Verzenden</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    ) : (
                        <div styleName="confirm">
                            <h2>Bedankt voor je feedback!</h2>
                            <p>
                                Deze wordt meegenomen in de terugkoppeling naar
                                het opleidings- en trainingsbureau of trainer.
                                Op deze manier optimaliseren wij ons leeraanbod.{' '}
                            </p>
                            <Button
                                onClick={() => {
                                    window.location.href = '/';
                                }}
                            >
                                Terug naar overzicht
                            </Button>
                        </div>
                    )}
                </HeroLayout>
            </Container>
        </Layout>
    );
}
